var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (typeof _vm.geometryData === 'undefined' && !_vm.expansion) ||
      (_vm.geometryData.class === 'geometry' && !_vm.expansion)
  )?_c('v-expansion-panel',[_c('material-form'),_c('v-expansion-panel-header',[_vm._v("Material")]),_c('v-expansion-panel-content',[_c('material-box')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }